function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useMemo } from "react";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { useCarousel } from "./CarouselContext";
import Dot from "./Dot";
import useStyle from "./Dots.style";
export var Dots = function() {
    var ref = useCarousel(), _state = ref.state, testID = _state.testID, nextSlidesCount = _state.nextSlidesCount, previousSlidesCount = _state.previousSlidesCount, slideIndex = _state.slideIndex, isRtl = _state.isRtl, dotsMargin = _state.dotsMargin, dotsSize = _state.dotsSize, slideCount = _state.slideCount, cols = _state.cols, dotsAriaLabel = _state.dotsAriaLabel, _actions = ref.actions, goNext = _actions.goNext, goPrevious = _actions.goPrevious, setSlideIndex = _actions.setSlideIndex;
    var handleNextTab = function() {
        if (nextSlidesCount > 0) {
            goNext();
        }
    };
    var handlePreviousTab = function() {
        if (previousSlidesCount > 0) {
            goPrevious();
        }
    };
    var handleKeyDown = function(event) {
        var end = cols ? slideCount - cols : slideCount;
        var start = 0;
        switch(event.key){
            case 'ArrowLeft':
                {
                    if (isRtl) {
                        return handleNextTab();
                    }
                    return handlePreviousTab();
                }
            case 'ArrowRight':
                {
                    if (isRtl) {
                        return handlePreviousTab();
                    }
                    return handleNextTab();
                }
            case 'Home':
                setSlideIndex(start);
                break;
            case 'End':
                setSlideIndex(end);
                break;
            default:
                break;
        }
    };
    var visibleDots = useMemo(function() {
        return nextSlidesCount + previousSlidesCount + 1;
    }, [
        nextSlidesCount,
        previousSlidesCount
    ]);
    var wrapper = useStyle({
        isRtl: isRtl,
        dotsMargin: dotsMargin,
        visibleDots: visibleDots
    }).wrapper;
    var dots = useMemo(function() {
        var _dots = [];
        for(var i = 0; i < slideCount; i++){
            _dots.push(_jsx(Dot, {
                index: i,
                distanceFromActive: i - slideIndex,
                numberOfDots: visibleDots,
                dotsAriaLabel: dotsAriaLabel,
                dotSize: dotsSize,
                isHidden: visibleDots <= i || visibleDots === 1,
                hiddenLastSlide: visibleDots - 1
            }, i));
        }
        return _dots;
    }, [
        slideCount,
        visibleDots,
        slideIndex,
        dotsSize,
        dotsAriaLabel
    ]);
    return _jsx("div", _objectSpread({
        css: wrapper,
        role: "tablist",
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, injectTestId(testID && "".concat(testID, ".dots")), {
        children: dots
    }));
};
export default Dots;
